/**
 * Book-a-table URL pathnames are locale-independent entry points.
 * UI language may follow the URL as a hint, but every variant must route.
 */

export var BOOK_TABLE_BASE_PATHS = ["/prenota-un-tavolo", "/reserver-une-table"];
export var BOOK_TABLE_FROM_RESTAURANT_PATHS = ["/prenota-un-tavolo/daRistorante", "/reserver-une-table/duRestaurant"];
export var BOOK_TABLE_EDIT_PATHS = ["/prenota-un-tavolo/modifica", "/reserver-une-table/modifier"];
export var BOOK_TABLE_RESERVATION_PATHS = ["/prenota-un-tavolo/prenotazione", "/reserver-une-table/reservation"];

/** Path segments used in reservation detail URLs (…/prenotazione|reservation/:id). */
export var BOOK_TABLE_RESERVATION_SEGMENTS = ["prenotazione", "reservation"];
export function getBookTableUrlsForPathname() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (pathname.startsWith("/reserver-une-table")) {
    return {
      base: "/reserver-une-table",
      fromRestaurant: "/reserver-une-table/duRestaurant",
      edit: "/reserver-une-table/modifier",
      reservation: "/reserver-une-table/reservation"
    };
  }
  return {
    base: "/prenota-un-tavolo",
    fromRestaurant: "/prenota-un-tavolo/daRistorante",
    edit: "/prenota-un-tavolo/modifica",
    reservation: "/prenota-un-tavolo/prenotazione"
  };
}
export function isBookTablePath() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return BOOK_TABLE_BASE_PATHS.some(base => pathname === base || pathname.startsWith("".concat(base, "/")));
}
export function isBookTableReservationPath() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return BOOK_TABLE_RESERVATION_PATHS.some(path => pathname === path || pathname.startsWith("".concat(path, "/")));
}
export function getLanguageFromBookTablePath() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (pathname.startsWith("/reserver-une-table")) {
    return "fr";
  }
  return null;
}